const { isUndNullEmpNew, } = require('../../helpers/UtilsHelper');

export class UserClass {
    constructor(
        id = '',
        appSecretKey = '',
        appId = 0,
        secondId = 0,
        firstName = '',
        lastName = '',
        phone = '',
        pictureUrl = '',
        email = '',
        userId = '',
        password = '',
        createAtFm = new Date()?.toISOString(),
        createAt = new Date()?.toISOString(),
        appUrl = '',
        address = '',
        // notifications = new UserNotificationsClass()?.getClass(),
        notifications = UserNotificationsClass?.getClass(),
        userName = '',
        code = '',
    ) {
        this.id = id;
        this.appSecretKey = appSecretKey;
        this.appId = appId;
        this.secondId = secondId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.phone = phone;
        this.pictureUrl = pictureUrl;
        this.email = email;
        this.userId = userId;
        this.password = password;
        this.createAtFm = createAtFm;
        this.createAt = createAt;
        this.appUrl = appUrl;
        this.address = address;
        this.notifications = notifications;
        this.userName = userName;
        this.code = code;
    }

    static getClassName = () => {
        return 'User - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName(), })?.result) {
            return new UserClass(
                obj?.id,
                obj?.appSecretKey,
                obj?.appId,
                obj?.secondId,
                obj?.firstName,
                obj?.lastName,
                obj?.phone,
                obj?.pictureUrl,
                obj?.email,
                obj?.userId,
                obj?.password,
                obj?.createAtFm,
                obj?.createAt,
                obj?.appUrl,
                obj?.address,
                obj?.notifications,
                obj?.userName,
                obj?.code
            );
        }

        return new UserClass();
    }
}

class UserNotificationsClass {
    constructor(
        telegram = 0,
        email = '',
    ) {
        this.telegram = telegram;
        this.email = email;
    }

    static getClassName = () => {
        return 'User notifications - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName(), })?.result) {
            return new UserNotificationsClass(
                obj?.telegram,
                obj?.email,
            );
        }

        return new UserNotificationsClass();
    }
}

// {
//   id: "vixRI8SGHGFBoqgUFozo",
//   appSecretKey: "dsXLNpN9e0ZMWxtsTAPfa9sA1lyLDQiN",
//   appId: 6259530655372521,
//   secondId: 56876918,
//   firstName: "Eduardo C.",
//   lastName: "Herrera J.",
//   phone: "0424-2703231",
//   pictureUrl: "https://mla-s1-p.mlstatic.com/648606-MLA28174769904_092018-O.jpg",
//   email: "carlos.e.herrera.j@gmail.com",
//   userId: "5QwpU0cajnSyDZhBjpvHZQsrm9D3",
//   password: "5654chej",
//   createAtFm: {
//     _nanoseconds: 67000000,
//     _seconds: 1616516117,
//   },
//   createAt: {
//     _nanoseconds: 67000000,
//     _seconds: 1616516117,
//   },
//   appUrl: "https://mercadolibreapi.web.app/userCode",
//   address: "Calle Libertador con Pichicha 1020, Mun. Libertador (Oeste), DISTRITO FEDERAL, 1050, ",
//   notifications: {
//     telegram: 845420153,
//     email: "mercadolibrevzla.soporte@gmail.com",
//   },
//   userName: "Carlos.e.herrera.j",
//   code: "TG-6833b49f5f5a120001233d4d-56876918",
// }